import React from "react";
import PageRenderer from "../components/PageRender";

const Estrazioni = () => {
  return <PageRenderer pageIdentifier="estrazioni-biglietti" />;
};

export default Estrazioni;